import { Component, Input, ViewEncapsulation } from '@angular/core';
import { TooltipInterface } from '../../../../../utils/models/miscelanea.interface';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
  standalone: true,
  imports: [CommonModule, MatTooltipModule]
})
export class TooltipComponent {

  @Input() tooltip: TooltipInterface;
}
